// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {362: "c96348ef6f5978f4",898: "274469effacd867e",}[chunkId] + ".css"
}